import { store } from "../redux/store";
import { getDecryptedValue } from "../config/lenderEncryption";
import AfterOnboardAPI from "../services/AfterOnboardAPI";
import { PREVIOUS_ROUTE_LOCAL_STORAGE_KEY, PAYMENT_RESPONSE_LOCAL_STORAGE_KEY } from "../Constants/constant";
import { handleShowContextualLoader, handlehideContextualLoader } from "../utils/contextualLoaderTrigger";
import { 
  REACT_APP_ROZAR_PAY_KEY, 
  REACT_APP_RAZORPAY_REPAYMENT_KEY_NAME, 
  REACT_APP_ROZAR_PAY_SDK_URL, 
  REACT_APP_PAYU_SDK_URL,
} from "../utils/environment";
import { setPaymentResponse } from "../redux/slices/userSlice";
import { getLeadID } from "../utils/storage";
import { PAYMENT_GATEWAY } from "../Constants/constant";

// After Onboard API instance

const { getLenderPaymentDetailsAPI } = new AfterOnboardAPI();

// Rozarpay Mandate
export const rozarPayMandate = async (data) => {
  const lenderPaymentDetails = await getLenderPaymentDetailsAPI();
  const keys = lenderPaymentDetails?.data.lenderCreds?.["RazorPay Emandate"]?.razorpay_disbursal_key_id;
  const decryptedKey = await getDecryptedValue(keys);

  const host = window.location.href.split("/");

  const options = {
    key: decryptedKey,
    customer_id: data.customer_id,
    order_id: data.order_id,
    recurring: 1,
    callback_url: host[0] + "//" + host[2] + "/emandate-status",
    notes: {
      disableWebhook: true,
    },
    theme: {
      color: "#182bda",
    },
  };

  await openRazorpay(options);
};

// Rozarpay Loan Payment
export const rozarLoanPayment = async (data) => {
  const lenderPaymentDetails = await getLenderPaymentDetailsAPI();
  const razorpayDisbursalKeyId = lenderPaymentDetails?.data.lenderCreds?.[REACT_APP_RAZORPAY_REPAYMENT_KEY_NAME]?.razorpay_disbursal_key_id;
  const decryptedKey = await getDecryptedValue(razorpayDisbursalKeyId);
  const { id, amount, currency="INR", name, email, phone } = data;
  store.dispatch(setPaymentResponse({})); // Clear any existing payment response before initiating new payment
  await openRazorpay(
    {
      order_id: id,
      key: decryptedKey || REACT_APP_ROZAR_PAY_KEY,
      amount,
      currency,
      name,
      email,
      phone,
      handler: async function (response) {
        storePaymentResponseAndRedirect(response, PAYMENT_GATEWAY.ROZAR_PAY);
        return false;
      }
    },
  );
};


// payU Loan Payment
export const payULoanPayment = async (data) => {
  const { amount, firstname, email, key, hash, txnid, productinfo, phone, surl, furl, udf1 } = data;
  store.dispatch(setPaymentResponse({})); // Clear any existing payment response before initiating new payment
  await openPayU(
    {
      key,
      txnid,
      amount,
      firstname,
      email,
      productinfo,
      hash,
      phone: phone+'',
      surl,
      furl,
      udf1
    },
  );
};

// --- Common helpers (kept at bottom so exported functions remain grouped) ---
const loadScript = (src) =>
  new Promise((resolve, reject) => {
    try {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = () => resolve(script);
      script.onerror = (err) => reject(err || new Error(`Failed to load ${src}`));
      document.body.appendChild(script);
    } catch (e) {
      reject(e);
    }
  });

const storePaymentResponseAndRedirect = (paymentResponse, type) => {
  try {
    handleShowContextualLoader("Please wait...");
    if(paymentResponse) {
      const responseToStore = type === PAYMENT_GATEWAY.PAYU ? { 
        txnid: paymentResponse?.initiatePaymentTxnID,
        txnStatus: paymentResponse?.txnStatus || "pending",
      } : {
        orderID: paymentResponse?.razorpay_order_id,
        paymentID: paymentResponse?.razorpay_payment_id,
        txnStatus: paymentResponse?.txnStatus || "pending",
      };
      store.dispatch(setPaymentResponse({...responseToStore, leadID: getLeadID()}));
      setTimeout(()=> window?.location.replace("/payment-status"), 300);
    }
  } catch (err) {
    setTimeout(()=> window?.location.replace("/home"), 300);
    console.error("Failed to store payment response:", err);
  }
  // Navigate to payment status page
}

const openRazorpay = async (options) => {
  await loadScript(REACT_APP_ROZAR_PAY_SDK_URL);
  const rzp = new window.Razorpay(options);
  rzp.open();
};

const openPayU = async (options) => {
  await loadScript(REACT_APP_PAYU_SDK_URL);
  const { txnid } = options;
  var handlers = {
    responseHandler: function (BOLT) { 
      storePaymentResponseAndRedirect({...BOLT.response, initiatePaymentTxnID: txnid}, PAYMENT_GATEWAY.PAYU);
    },
    catchException: function (BOLT) {
      handlehideContextualLoader();
      // Swal.fire({
      //   icon: "error",
      //   text: toSentenceCase(BOLT.message),
      // });
      console.log('Payment failed. Please try again.');
    }
  };
  window.bolt && window.bolt.launch(options, handlers);
};

